
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

const trimSpeed = 7;
type processAction = 'init' | 'unfold' | 'fold';
@Component
export default class ParagraphWithFold extends Vue {
  @Prop() text!: string;
  @Prop({ default: 5 }) maxLine!: number;

  btnStatus = 0; // 0-展开 1-收起
  btnText = ['...展开', '...收起'];
  displayText = '';
  contentOverFlow = false; // 表示是否超长

  @Watch('text', {
    immediate: true,
  })
  onTextChange(newval: string, oldval: string) {
    // console.log('change', newval, '----%%%and%%%---', oldval);
    this.displayText = newval;
    this.$nextTick(() => {
      this.processContent();
    });
  }

  processContent() {
    // * 此处注意，内联的操作按钮也会占一行，故需加入显示隐藏按钮时的条件判断
    // TODO 此处逻辑仍有优化空间
    const content = this.$refs.content as HTMLParagraphElement;
    this.$nextTick(() => {
      const lineCount = content.getClientRects().length;
      // console.log(lineCount);
      if (!this.contentOverFlow && lineCount > this.maxLine) {
        // console.log('recur data', lineCount);
        this.contentOverFlow = true;
        this.displayText = this.displayText.slice(0, -trimSpeed);
        this.processContent();
      } else if (this.contentOverFlow && lineCount - 1 > this.maxLine) {
        this.displayText = this.displayText.slice(0, -trimSpeed);
        this.processContent();
      }
    });
  }
  onSwitch() {
    if (this.btnStatus === 0) {
      this.displayText = this.text;
      this.btnStatus = 1;
    } else if (this.btnStatus === 1) {
      this.btnStatus = 0;
      this.processContent();
    }
  }
}
